import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Radio } from "antd";
import Collapse, { Panel } from "../../../../common/component/Collapse";
import {
  FormWrapperInputComponent,
  HeaderComponent
} from "../../../../common/component/Index";
import Wrapper from "../../../../common/component/Wrapper";
import {
  DETAIL_ACTIONS,
  CAMPAIGN as CAMPAIGN_ENUM
} from "../../../../../../constants/Define";
import {
  capitalizeFirstLetter,
  checkUndefine
} from "../../../../../../helpers/functions";
import { useTranslation } from "react-i18next";
import { toArray, range } from "lodash";
import AntSelect, { AntOption } from "../../../../common/component/AntSelect";
import Input from "../../../../common/component/Input";
import { formatPercentValue } from "../../../../../../utils/commonUtils";
import Span from "../../../../common/component/Span";

const defaultCollapseKey = "formatCodeSection";

function FormatCodeSection(props) {
  const {
    createType,
    campaign,
    validation,
    action,
    onChange,
    renderInfoTooltip
  } = props;

  const { t } = useTranslation();
  const [collapseKey, setCollapseKey] = useState();

  const renderFormatCodeHint = () => {
    const codeSuffixLength = campaign.codeCharCount || 0;
    const codeSuffix =
      codeSuffixLength > 0 &&
      range(codeSuffixLength || 1)
        .map(item => item + 1)
        .join("");
    const codePrefix = campaign.codePrefix || "";
    const isShowHint = !!(codePrefix || codeSuffix);
    return (
      isShowHint && (
        <Span className="text-ellipsis max-width-300 ml-2">
          {t(`item.campaign.formatCodeExample`)}
          <Span className="font-bold ml-1">{codePrefix}</Span>
          <Span>{codeSuffix}</Span>
        </Span>
      )
    );
  };

  const onChangeDiscountValue = (value, type) => {
    type = type || campaign.discountType;
    return onChange(
      "discountValue",
      formatPercentValue(
        value,
        type === CAMPAIGN_ENUM.DISCOUNT_TYPE.PERCENT.id ? 100 : null
      )
    );
  };

  const onToggleCollapse = () => {
    if (collapseKey) {
      // close
      setCollapseKey();
    } else {
      // open
      setCollapseKey(defaultCollapseKey);
    }
  };

  useEffect(() => {
    const hasError = validation && (
      validation.codePrefix ||
      validation.promotionType ||
      validation.maxCodeCount ||
      validation.discountMode ||
      validation.discountType ||
      validation.discountValue ||
      validation.maxDiscountValue
    )
    if (hasError && !collapseKey) {
      setCollapseKey(defaultCollapseKey);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validation])

  return (
    <Collapse
      activeKey={collapseKey}
      bordered={false}
      defaultActiveKey={defaultCollapseKey}
      style={{ width: "100%", background: "inherit" }}
      expandIconPosition={"right"}
      onChange={onToggleCollapse}
    >
      <Panel
        key={defaultCollapseKey}
        header={
          <HeaderComponent
            title={t("item.campaign.formatCode")}
            className="col-md-12"
            style={{
              userSelect: "none",
              paddingTop: "unset",
              paddingBottom: "unset"
            }}
          />
        }
      >
        <Wrapper className={"row campaign-collapse-row"}>
          <Wrapper className="col-md-6">
            <FormWrapperInputComponent
              visible={action !== DETAIL_ACTIONS.TRANSLATE}
              isRequired={true}
              isValidation={true}
              dataValidation={
                campaign.codeType === CAMPAIGN_ENUM.CODE_TYPE.STANDARD.id
                  ? (campaign.codePrefix || "") + (campaign.codeCharCount || "")
                  : campaign.maxCodeCount
              }
              validation={
                campaign.codeType === CAMPAIGN_ENUM.CODE_TYPE.STANDARD.id
                  ? validation.codePrefix
                  : validation.maxCodeCount
              }
              labelTitle={
                <>
                  {t(`item.campaign.formatCode`)}
                  <Radio.Group
                    value={campaign.codeType}
                    onChange={e => onChange("codeType", e.target.value)}
                    className="ml-3"
                    disabled={!campaign.canEdit}
                  >
                    {toArray(CAMPAIGN_ENUM.CODE_TYPE).map(item => (
                      <Radio
                        key={item.key}
                        value={item.id}
                        className="mr-0"
                        disabled={campaign[item.disabledByKey]}
                      >
                        {t(`item.campaign.codeType.${item.key}`)}
                      </Radio>
                    ))}
                  </Radio.Group>
                </>
              }
            >
              {campaign.codeType === CAMPAIGN_ENUM.CODE_TYPE.STANDARD.id ? (
                <Wrapper className="row">
                  <Wrapper className="col-md-6">
                    <Input
                      type="text"
                      autoComplete="off"
                      placeholder={t("item.campaign.codePrefix")}
                      className="form-control"
                      name="codePrefix"
                      onChange={e =>
                        onChange(
                          "codePrefix",
                          String(e.target.value).toUpperCase()
                        )
                      }
                      value={campaign.codePrefix ? campaign.codePrefix : ""}
                      disabled={!campaign.canEdit}
                    />
                  </Wrapper>
                  <Wrapper className="col-md-6">
                    <Input
                      type="text"
                      autoComplete="off"
                      placeholder={t("item.campaign.codeCharCountPlaceHolder")}
                      className="form-control text-right"
                      name="codeCharCount"
                      onChange={e =>
                        onChange("codeCharCount", Number(e.target.value))
                      }
                      value={
                        campaign.codeCharCount ? campaign.codeCharCount : ""
                      }
                      disabled={!campaign.canEdit}
                    />
                  </Wrapper>
                </Wrapper>
              ) : (
                <Wrapper className="row">
                  <Wrapper className="col-md-12">
                    <Input
                      type="number"
                      autoComplete="off"
                      placeholder={t("item.campaign.maxCodeCount")}
                      className="form-control text-right"
                      name="maxCodeCount"
                      onChange={e =>
                        onChange("maxCodeCount", Number(e.target.value))
                      }
                      value={campaign.maxCodeCount ? campaign.maxCodeCount : ""}
                      disabled={!campaign.canEdit}
                    />
                  </Wrapper>
                </Wrapper>
              )}
              {renderFormatCodeHint()}
            </FormWrapperInputComponent>
            <FormWrapperInputComponent
              isRequired={true}
              isValidation={true}
              dataValidation={campaign.promotionType}
              validation={validation.promotionType}
              visible={action !== DETAIL_ACTIONS.TRANSLATE}
              labelTitle={
                campaign.promotionType ===
                CAMPAIGN_ENUM.PROMOTION_TYPE.UNIQUE.id
                  ? renderInfoTooltip(
                      t(
                        `item.campaign.promotionTypes.hints.${CAMPAIGN_ENUM.PROMOTION_TYPE.UNIQUE.key}`
                      ),
                      t(`item.campaign.promotionType`),
                      "ml-2"
                    )
                  : t(`item.campaign.promotionType`)
              }
            >
              <Wrapper className="row">
                <Wrapper className="col-md-6">
                  <AntSelect
                    className="select-types"
                    showArrow
                    placeholder={t("item.campaign.promotionType")}
                    value={campaign.promotionType}
                    onChange={type => onChange("promotionType", type)}
                    style={{ width: "100%" }}
                    disabled={!campaign.canEdit}
                  >
                    {toArray(CAMPAIGN_ENUM.PROMOTION_TYPE).map(item => (
                      <AntOption key={item.key} value={item.id}>
                        {t(`item.campaign.promotionTypes.${item.key}`)}
                      </AntOption>
                    ))}
                  </AntSelect>
                </Wrapper>
                <Wrapper className="col-md-6">
                  <Input
                    type="text"
                    autoComplete="off"
                    placeholder={t("item.campaign.maxUseCount")}
                    className="form-control text-right"
                    name="maxUseCount"
                    onChange={e =>
                      onChange("maxUseCount", Number(e.target.value))
                    }
                    value={campaign.maxUseCount ? campaign.maxUseCount : ""}
                    disabled={!campaign.canEdit}
                  />
                </Wrapper>
              </Wrapper>
            </FormWrapperInputComponent>
          </Wrapper>
          {createType !== CAMPAIGN_ENUM.CREATE_TYPE.HOTEL && (
            <Wrapper className="col-md-6">
              <FormWrapperInputComponent
                isValidation={true}
                dataValidation={campaign.discountMode}
                validation={validation.discountMode}
                messageBelowInput={true}
                labelTitle={t("item.campaign.bonusType")}
                visible={action !== DETAIL_ACTIONS.TRANSLATE}
              >
                <Wrapper>
                  <Radio.Group
                    value={campaign.bonusType}
                    onChange={e => onChange("bonusType", e.target.value)}
                  >
                    {toArray(CAMPAIGN_ENUM.BONUS_TYPE).map(item =>
                      renderInfoTooltip(
                        !item.disabled &&
                          t(`item.campaign.bonusTypes.description.${item.key}`),
                        <Radio
                          key={item.key}
                          value={item.id}
                          disabled={item.disabled}
                          className="mr-0"
                        >
                          {t(`item.campaign.bonusTypes.${item.key}`)}
                        </Radio>,
                        "mr-3"
                      )
                    )}
                  </Radio.Group>
                  <Radio.Group
                    value={campaign.discountMode}
                    onChange={e => onChange("discountMode", e.target.value)}
                    style={{ marginTop: 10 }}
                  >
                    {toArray(CAMPAIGN_ENUM.DECREACE_TYPE).map(item => (
                      <Radio
                        key={item.id}
                        disabled={
                          createType === CAMPAIGN_ENUM.CREATE_TYPE.MARKUP &&
                          item.key === "ITEM"
                        }
                        value={item.key}
                        className="mr-0"
                      >
                        {t(`item.campaign.discountMode.${item.id}`)}
                      </Radio>
                    ))}
                  </Radio.Group>
                </Wrapper>
              </FormWrapperInputComponent>
              <FormWrapperInputComponent
                isValidation={true}
                dataValidation={campaign.discountValue}
                validation={validation.discountType || validation.discountValue}
                messageBelowInput={true}
                className="with-fix with-currency-suffix"
                labelTitle={t(`item.campaign.bonusValue`)}
                visible={action !== DETAIL_ACTIONS.TRANSLATE}
              >
                <Wrapper className="row">
                  <Wrapper className="col-md-6">
                    <AntSelect
                      className="select-types"
                      showArrow
                      placeholder={capitalizeFirstLetter(
                        (
                          t("placeHolderForm.select") +
                          " " +
                          t("item.campaign.discountType")
                        ).toLowerCase()
                      )}
                      value={campaign.discountType}
                      onChange={type => {
                        onChangeDiscountValue(campaign.discountValue, type);
                        return onChange("discountType", type);
                      }}
                      style={{ width: "100%" }}
                    >
                      {toArray(CAMPAIGN_ENUM.DISCOUNT_TYPE).map(
                        item =>
                          !item.hide && (
                            <AntOption
                              key={item.key}
                              value={item.id}
                              disabled={item.disabled}
                            >
                              {t(`item.campaign.discountTypes.${item.key}`)}
                            </AntOption>
                          )
                      )}
                    </AntSelect>
                  </Wrapper>
                  <Wrapper className="col-md-6">
                    <Input
                      type="currency"
                      autoComplete="off"
                      suffix={
                        campaign.discountType ===
                        CAMPAIGN_ENUM.DISCOUNT_TYPE.AMOUNT.id
                          ? t(`currency`)
                          : campaign.discountType ===
                            CAMPAIGN_ENUM.DISCOUNT_TYPE.PERCENT.id
                          ? "%"
                          : undefined
                      }
                      placeholder={capitalizeFirstLetter(
                        (
                          t("placeHolderForm.input") +
                          " " +
                          t("item.campaign.discountValue")
                        ).toLowerCase()
                      )}
                      className="form-control"
                      name="discountValue"
                      onChange={e => onChangeDiscountValue(e.target.value)}
                      value={campaign.discountValue}
                    />
                  </Wrapper>
                </Wrapper>
              </FormWrapperInputComponent>
              {campaign.discountType ===
                CAMPAIGN_ENUM.DISCOUNT_TYPE.PERCENT.id && (
                <FormWrapperInputComponent
                  dataValidation={campaign.maxDiscountValue}
                  validation={validation.maxDiscountValue}
                  className="with-fix with-currency-suffix"
                  messageBelowInput={true}
                  labelTitle={t(`item.campaign.maxDiscountValue`)}
                  visible={action !== DETAIL_ACTIONS.TRANSLATE}
                >
                  <Input
                    type="currency"
                    autoComplete="off"
                    suffix={t(`currency`)}
                    className="form-control"
                    name="maxDiscountValue"
                    onChange={e =>
                      onChange("maxDiscountValue", Number(e.target.value))
                    }
                    value={checkUndefine(campaign.maxDiscountValue)}
                  />
                </FormWrapperInputComponent>
              )}
            </Wrapper>
          )}
        </Wrapper>
      </Panel>
    </Collapse>
  );
}

FormatCodeSection.propTypes = {
  campaign: PropTypes.object,
  validation: PropTypes.object,
  action: PropTypes.string,
  onChange: PropTypes.func,
  setCampaign: PropTypes.func,
  renderInfoTooltip: PropTypes.func
};

FormatCodeSection.defaultProps = {
  campaign: {},
  validation: {},
  action: "",
  onChange: () => {},
  setCampaign: () => {},
  renderInfoTooltip: () => {}
};

export default FormatCodeSection;
